import { Tag, TopicType } from '../../../../ontology.model';

export const arithmeticTags: Tag[] = [
  {
    id: 'tag.arith',
    name: 'Arithmetic',
    parent_id: 'tag.seq',
    topic_type: TopicType.Generative,
    icon: 'plus-minus',
    description: 'Sequences with a constant common difference.',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
  {
    id: 'tag.arith.seq',
    name: 'Sequence',
    parent_id: 'tag.arith',
    icon: 'list-ol',
    description: 'Properties related to the terms ($u_n$).',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
  {
    id: 'tag.arith.series',
    name: 'Series',
    parent_id: 'tag.arith',
    icon: 'layer-group',
    description: 'Properties related to the sum of terms ($S_n$).',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
];
